// extracted by mini-css-extract-plugin
export default {"container":"Vl-z","bubbleNav":"Wl-z","graphic":"Xl-z","contact":"Yl-z"};